export default function guestlistEditAlertHandler($injector, e) {
    const alert = $injector.get('Alert'),
        api = $injector.get('$http'),
        translator = $injector.get('$translate');

    console.log(e);

    return new Promise((resolve, reject) => {
        if (e.status === 409 && _.get(e.data, 'message', null) === 'invalid_guestlist_hash') {
            alert
                .animatedAlert(
                    translator.instant('guestlists.helpers.guestlist-edit-alert-handler.ask-force.title'),
                    translator.instant('guestlists.helpers.guestlist-edit-alert-handler.ask-force.content'),
                    'attention',
                    {
                        confirmButtonText: translator.instant('guestlists.helpers.guestlist-edit-alert-handler.ask-force.save'),
                        cancelButtonText: translator.instant('guestlists.helpers.guestlist-edit-alert-handler.ask-force.cancel'),
                    }
                )
                .then(() => {
                    const config = e.config;
                    e.config.headers['x-festzelt-os-guestlist-version-hash-force'] = 1;

                    api(config)
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                })
                .catch(() => {
                    resolve();
                })
        } else {
            reject(e)
        }
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/helpers/guestlist-edit-alert-handler.js